import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { fetchProjectDetails } from '../../store/app/apis';
import { getTime } from '../../utils';
import { PROJECT_STATUS } from '../../constants';
import styles from './Projectdetails.module.css';
import { useParams } from 'react-router-dom';

function Projectdetails({ projectList, fetchProjectDetails }) {
  const [project, setProject] = useState({});
  const params = useParams();
  useEffect(() => {
    const id = params.id;
    if (projectList?.length !== 0 && projectList?.find((project) => project.id === id))
      setProject(projectList?.find((project) => project.id === id));
    else {
      fetchProjectDetails(id).then((res) => {
        setProject(res);
      });
    }
  }, [params.id, projectList]);
  return (
    <div className={styles.alerts}>
      <div className={styles.leftDiv}>
        {project?.title && (
          <div className={styles.common}>
            Project Name
            <span>{project?.title}</span>
          </div>
        )}
        {project?.hookid && (
          <div className={styles.common}>
            Hook
            <span>{project?.hookid}</span>
          </div>
        )}
        {project?.ct && (
          <div className={styles.common}>
            Created Time
            <span>{getTime(project?.ct)}</span>
          </div>
        )}

        <div className={styles.common}>
          Modified Time
          <span>{!project?.mt || project?.mt === 0 ? 'NOT MODIFIED' : getTime(project?.mt)}</span>
        </div>

        {(project?.status === 0 || project?.status) && (
          <div className={styles.common}>
            Status
            <span>{project?.status === PROJECT_STATUS.PROJECT_CREATED ? 'PROJECT CREATED' : 'PROJECT ARCHIVED'}</span>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    projectList: state.app.projectList,
  };
};
const mapDispatchToProps = { fetchProjectDetails };

export default connect(mapStateToProps, mapDispatchToProps)(Projectdetails);
